import { render } from "./EcommerceComponent.vue?vue&type=template&id=46ba0946"
import script from "./EcommerceComponent.vue?vue&type=script&lang=js"
export * from "./EcommerceComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__